module.exports = __webpack_public_path__ + "img/Asset 1@2x.87e0e973.png";